/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';

import * as moment from 'moment';
import { checkNested } from 'utils/basic-utils';
import tinycolor from 'tinycolor2';

import { fbReporting } from 'src/app/plain-javascript/background-scripts/fb-reporting';

import TicketFilter from '@appLegacy/model/Ticket';
import { LoggerServiceFactory } from 'src/app/common/logging/LoggerServiceFactory';

const _lastReadableColor = { };
export default function TicketOps(scope, fbConnection) {
	this.scope = scope;
	this.state = scope.legacyRouting.oldStyleSnapshot();
	this.logger = LoggerServiceFactory.create('TicketOps');

	this.fb = fbConnection;

	this.duplicateOffset = 25;
	this.timesAddClicked = 0;
}

TicketOps.prototype = {

	//### bulkAdd(list)
	// called by the bulk add ui. Perfoms some clean up, then calls add.
	//* a list of data to turn into tickets
	bulkAdd(list) {
		if (!list || !list.length) { Logging.debug('list is empty'); return; }
		const self = this;
		const pullUpdate = this.scope.plan.$ref().child('pullUpdateDisabled');

		this.fakeRoles(list, this.scope.roles.fb);
		this.fakeLocations(list, this.scope.locations);

		this.allowIfExists(list, this.scope.priorities, 'priorityId');
		this.allowIfExists(list, this.scope.projectMembers.fb, 'creatorId');
		this.allowIfExists(list, this.scope.projectMembers.fb, 'responsibleProjectMemberId');
		this.allowIfExists(list, this.scope.projectMembers.fb, 'assignedProjectMemberId');

		//this.handleConstraints(list);

		const ticketList = [];
		const constraintList = [];
		list.forEach(function(t) {
			if (t.type === 'constraint') {
				constraintList.push(t);
			}
			else {
				ticketList.push(t);
			}
		});

		this.fb.set(pullUpdate, true)
		.then(function() {
			if (!ticketList.length) { return self.scope.$q.when(true); }
			return self.addTickets(ticketList, null, { silent: true, tickets: self.scope.tickets});
		})
		.then(function(ticketRes) {
			if (!constraintList.length) { return ticketRes; }
			return self.addTickets(constraintList, null, { silent: true, tickets: self.scope.tickets}).then(function(resultArray) {
				const p = [];
				resultArray.forEach(function(res) {
					p.push(self.scope.constraints2.addIndex(self.state.planId, res.$id));
				});
				return self.scope.$q.all(p);
			});
		})
		.then(function() { self.logger.log('TicketOperations: all done'); })
		.finally(function() { self.fb.remove(pullUpdate); });
	},

	allowIfExists: function allowIfExists(importList, fbList, id) {
		importList.forEach(function(t) {
			if (!fbList.$getRecord(t[id])) {
				delete t[id];
			}
		});
	},

	handleConstraints(importList) {
		importList.forEach(function(t) {
			if (t.type === 'constraint') {

			}
		});
	},

	//### fakeRoles(ticketList, rolesList)
	//check a list of tickets and roles for name matches
	//then either assigns the roleId, or makes a new role
	fakeRoles(ticketList, rolesList) {
		const self = this;
		const rolesMap = { };
		const alreadyCreatedRoles = { };
		rolesList.forEach(function(r, key) { rolesMap[r.data.roleName] = rolesList.$keyAt(key); });
		ticketList.forEach(function(ticket) {
			if (ticket.tempRoleName) {
				const trm = ticket.tempRoleName.trim();
				//set to existing role
				if (rolesMap[trm]) {
					ticket.roleId = rolesMap[trm];
				}
				else if (alreadyCreatedRoles[trm]) {
					ticket.roleId = alreadyCreatedRoles[trm];
				}
				//make new role
				else {
					self.logger.log('new role');
					const ref = rolesList.$ref();
					const roleId = ref.push();
					roleId.set({
						'roleId': roleId.key,
						'roleName': trm
					});
					ticket.roleId = roleId.key;
					alreadyCreatedRoles[trm] = roleId.key;
				}
				delete ticket.tempRoleName;
			}
		});
	},

	fakeLocations(ticketList, locationList) {
		const locationsMap = { };
		const alreadyCreatedLocations = { };
		locationList.forEach(function(r, key) { locationsMap[r.data.name] = locationList.$keyAt(key); });
		ticketList.forEach(function(ticket) {
			if (ticket.tempLocationName) {
				//set to existing location
				if (locationsMap[ticket.tempLocationName]) {
					ticket.locationId = locationsMap[ticket.tempLocationName];
				}
				else if (alreadyCreatedLocations[ticket.tempLocationName]) {
					ticket.locationId = alreadyCreatedLocations[ticket.tempLocationName];
				}
				//make new location
				else {
					const ref = locationList.$ref().ref;
					const locationId = ref.push();
					locationId.set({
						//"locationId": locationId.key,
						'name': ticket.tempLocationName
					});
					ticket.locationId = locationId.key;
					alreadyCreatedLocations[ticket.tempLocationName] = locationId.key;
				}
				delete ticket.tempLocationName;
			}
		});
	},

	//performs all the calculations necessary to center a ticket via matrix transform
	//returns the string to provide as the css transform (transform: theStringReturned)
	generateCenterString(id) {
		const scope = this.scope;
		//abort if something horrendous happens
		if (!scope.tickets.$getRecord(id)) {
			Logging.debug('MOC-1554 would have fired');
			return 'initial';
		}
		const ticket = scope.tickets.$getRecord(id);

		const stickyWidth = 330;
		const stickyHeight = 320;

		const offsetX = (scope.hud.x ? scope.hud.x : 0);
		const offsetY = (scope.hud.y ? scope.hud.y : 0);

		const stickyX = ticket.data.left;
		const stickyY = ticket.data.top;

		const x = (scope.hud.shiftedW / scope.hud.z - stickyWidth) / 2;
		const y = (scope.hud.h / scope.hud.z - stickyHeight) / 2;

		return 'matrix(' + [0.78 / scope.hud.z, 0, 0, 0.78 / scope.hud.z, -offsetX / scope.hud.z + x - stickyX, -offsetY / scope.hud.z + y - stickyY].join(',') + ')';
	},

	//convienence function to actually apply the center transform to the supplied ticket
	//has no internal validation so any external use will need to perform it's own checks
	//as to whether or not this is allowed
	moveToCenter(ticketId, element) {
		if (!ticketId) {
			if (this.scope.flags.stickyInEditMode) {
				ticketId = this.scope.flags.stickyInEditMode;
				element = this.scope.tickets.$getRecord(this.scope.flags.stickyInEditMode);
			}
			else {
				return;
			}
		}

		$(element).css({
			transform: this.generateCenterString(ticketId)
		});
	},

	validateAndLog(ticket) {
		const validation = ticket.validateChanges();
		if (validation) { Logging.warning(validation); }
		return validation;
	},

	cantAddTickets(tickets) {
		const scope = this.scope;
		//has role
		if (!scope.you.projectMember.roleId || !scope.currentRole.$id) {
			return 'You cannot add tickets without an assigned role.';
		}
	},

	//### addTickets(tObj, count, config)
	// adds...tickets. Function returns a promise that resolves once
	// all tickets have been added. Promise resolves to an array of
	// tickets the same length and order of the objects passed in.
	// This can be used to map old to new.
	//* count - the number of tickets to add (defaults to one)
	//* tObj - a thing representing the data to init a ticket with
	// can be undefined, an object or an array equal to count length
	//
	//#### config
	// * silent - don't open any tickets
	// * tickets [a firebaseTickets object] - used to override the default of $scope.tickets
	addTickets(tObj, count, config) {
		const scope = this.scope;
		const self = this;

		if (!config) { config = { }; }

		const tickets = config.tickets || scope.floatingTickets;

		const objArray = tickets.constructAddArray(tObj, count);

		const cant = this.cantAddTickets(objArray);
		if (cant) { Logging.warning(cant); return scope.$q.rejectErr(cant); }

		let pmId = scope.you.projectMember;
		pmId = pmId ? pmId.$id : null;

		//todo - now perform any necessary modifications to the array, then call tickets.add
		objArray.forEach(function(obj, arrayPosition) {
			if (!obj.roleId && obj.type !== 'constraint') { obj.roleId = checkNested(scope.currentRole, 'data', 'roleId') ? scope.currentRole.data.roleId : null; }
			obj.creatorId = pmId;
		});
		return tickets.add(objArray).then(function(resultArray) {
			//disabled, no opening edit
			return resultArray;
		});
	},

	adminOrRoleCheck(tickets) {
		const scope = this.scope;
		return scope.planAccessCheck.isAdminSync() || tickets.every(function(t) {
			return scope.planAccessCheck.hasAccessToTicketSync(t) && !t.data.promisePeriodPosition;
		});
	},

	//### deleteTickets:
	// deletes tickets
	//* rawTickets - something that represents tickets, is ran through scope.tickets.alwaysTickets
	//
	//#### config
	// * skipWarning [true/false] - don't display a confirmation prompt
	// * skipValidation [true/false] - skip precedence check
	// * tickets [a firebaseTickets object] - used to override the default of $scope.tickets
	deleteTickets(rawTickets, config) {
		if (!config) { config = { }; }
		const scope = this.scope;

		const newTicketList = config.tickets === scope.floatingTickets ? scope.planState.floatingTickets : scope.planState.tickets;

		const ticketList = scope.tickets.alwaysTickets(rawTickets);
		if (!ticketList) { return; }

		const newTickets = scope.planState.legacyActions.getNewTicketsFromOld(ticketList, newTicketList);
		const newConfig = { ticketListOverride: newTicketList, disableConfirmation: config.skipWarning};
		scope.validatedPlanActions.tryDeleteTickets(newTickets, newConfig);
	},

	// This function returns a string suitable for ng-style from a ticket item
	// This just does placement
	getItemStyle(t) {
		if (!t || !t.data) { return; }
		const obj: any = {
			left: t.data.left + 'px',
			top: t.data.top + 'px',
			zIndex: t.data.zorder
		};
		if (t.data.width) {
			obj.width = t.data.width + 'px';
		}
		if (t.data.height) {
			obj.height = t.data.height + 'px';
		}
		return obj;
	},

	getResponsibleRoleId(ticket) {
		const scope = this.scope;
		const requestedPmId = (ticket.data && ticket.data.requestedByProjectMemberId) ? ticket.data.requestedByProjectMemberId : null;
		const responsiblePmId = (ticket.data && ticket.data.responsibleProjectMemberId) ? ticket.data.responsibleProjectMemberId : requestedPmId;
		const record = scope.meshedUsers.$getPmRecord(responsiblePmId);
		const primaryRole = (record) ? record.data.roleId : 'no-role-style';
		const requestedByRole = (ticket.data.requestedByProjectMemberRoleId) ? ticket.data.requestedByProjectMemberRoleId : primaryRole;
		return (ticket.data.responsibleProjectMemberRoleId) ? ticket.data.responsibleProjectMemberRoleId : requestedByRole;
	},

	getColor(ticket) {
		const scope = this.scope;
		if (ticket.data.type === 'constraint') {
			// // var pmId = ticket.local && ticket.local.editMode ? ticket.local.assignedProjectMemberId : ticket.data.responsibleProjectMemberId;
			// var pmId = ticket.data.responsibleProjectMemberId || ticket.data.requestedByProjectMemberId || ticket.data.assignedProjectMemberId;
			// //this.logger.log('pmId', pmId);  //<--------------------- this is fine, it's the set that went retarded
			// if(!pmId){return "";}
			// var user = scope.meshedUsers.$getPmRecord(pmId);
			// //this.logger.log('user', pmId, user);
			return this.getResponsibleRoleId(ticket);
		}
		const roleId = ticket.local && ticket.local.editMode ? ticket.local.roleId : ticket.data.roleId;
		if (!roleId) { return ''; }
		return roleId;
	},

	stateCheckboxChanged(state, ticket) {
		const local = ticket.local;
		if (state === 'missed') {
			local.actualFinish = null;
		}
		else if (state === 'completed') {
			//default to ticket.plannedFinish
			if (ticket.data.plannedFinish || ticket.data.lastPlannedFinish) {
				const dat = ticket.data.plannedFinish || ticket.data.lastPlannedFinish;
				local.actualFinish = moment(dat).format('YYYY-MM-DD');
			}
		}

		if (local.promise) {
			local.promise.varianceReason = null;
			local.promise.varianceComment = null;
		}
	},

	clearStatus(ticket) {
		const local = ticket.local;
		local.state = null;
		local.actualFinish = null; //ticket.data.lastPlannedFinish || ticket.data.plannedFinish || null;
		if (local.promise) {
			local.promise.varianceReason = null;
			local.promise.varianceComment = null;
		}
	}
};
